import {
  GetProfDashboardQuery,
  UnPayedCaEleve
} from '../../../graphql/generated/graphql';
import {
  ClasseDef,
  ClasseDefWithUser,
  ClasseInfo
} from '../../../types/classe/classe.def';
import { ToRequiredType } from '../../../types/typeDef';
import { ElevesDashboardProf } from '../../../types/classe/maClasse';
import { getProfileInfoExtendedFromQuery } from '../user';
import { orderNeedToBeReminded } from '../../commande/orderNeedToBeReminded';

export const getClasseInfoFromQuery: (
  classe: GetProfDashboardQuery['getProfDashboard']['classe']
) => ClasseInfo = classe => ({
  lycee: {
    name: classe?.lycee?.name
  },
  filliere: {
    name: classe?.filiere?.name
  },
  niveau: {
    name: classe?.niveau?.name
  }
});

export const getClasseDefFromQuery: (
  classe: GetProfDashboardQuery['getProfDashboard']['classe']
) => ClasseDef = classe => {
  const { niveau, filliere } = getClasseInfoFromQuery(classe);
  return {
    ...classe,
    name: classe?.name,
    debut: classe?.debut,
    fin: classe?.fin,
    operationid: classe?.operationid,
    niveau,
    filliere,
    lycee: { name: classe?.lycee?.name }
  };
};

export const getElevesDashboardProfFromQuery = (
  user: GetProfDashboardQuery['getProfDashboard']['classe']['users'][0],
  unpayedCA?: UnPayedCaEleve['unpayedCA']
): ElevesDashboardProf => ({
  id: user?.id,
  firstname: user?.firstname,
  lastname: user?.lastname,
  note: user?.note as ToRequiredType<typeof user.note>,
  mdp: user?.mdp,
  shop: user?.shop,
  orderNeedToBeReminded: user.commandes.filter(
    order =>
      orderNeedToBeReminded(
        order.methodepaiement,
        order.status,
        order.paymentreminder,
        order.createdAt
      ) === true
  )?.length,
  quiztonote: user?.quiztonotes?.map(qtn => ({
    quiz: { id: qtn?.quiz?.id },
    note: qtn?.note,
    createdAt: qtn?.createdAt
  })),
  role: user?.role?.name,
  unpayedCa: unpayedCA && unpayedCA
});

export const getClasseDefWithUserAndNumbersOfOrderToRemindFromQuery: (
  classe: GetProfDashboardQuery['getProfDashboard']['classe']
) => ClasseDefWithUser = classe => ({
  ...getClasseDefFromQuery(classe),
  orderNeedToBeReminded: classe.users
    .map(u => getElevesDashboardProfFromQuery(u))
    .reduce(
      (nbOfOrderNeedToBeReminded, current) =>
        nbOfOrderNeedToBeReminded + current.orderNeedToBeReminded,
      0
    ),
  users: classe?.users?.map(u => getProfileInfoExtendedFromQuery(u))
});
